interface ReservationButtonProps {
  onReservation: () => void;
  disabled?: boolean;
  loading?: boolean;
}

export default function ReservationButton({
  onReservation,
  disabled = false,
  loading = false,
}: ReservationButtonProps) {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-t from-white to-transparent pt-6 px-[22px] pb-6">
      <button
        onClick={disabled || loading ? undefined : onReservation}
        disabled={disabled || loading}
        className={`w-full rounded-[10px] py-[19px] flex items-center justify-center transition-colors ${
          disabled || loading ? 'bg-[#D9D9D9] cursor-not-allowed' : 'bg-[#3D8AFF] hover:bg-[#2C6FE6]'
        }`}
      >
        {loading ? (
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            <span className="text-base font-semibold text-white">예약 신청 중...</span>
          </div>
        ) : (
          <span className={`text-base font-semibold ${disabled ? 'text-[#999]' : 'text-white'}`}>예약 신청하기</span>
        )}
      </button>
    </div>
  );
}
